import React, { useEffect, useState } from 'react';
import { useRegisterSystem } from '../../services/hooks/use-register-system';
import { useSystemFormOptions } from '../../services/hooks/use-system-form-options';
import { FormAdd } from '../FormAdd';
export const SystemCreate = ({ onCreated }) => {
    const [validationBackend, setValidationBackend] = useState(null);
    const { mutate: registerSystem, data: registerSystemResponse, isLoading: submittingSystem } = useRegisterSystem(setValidationBackend);
    useEffect(() => {
        if (registerSystemResponse?.isSuccess) {
            onCreated(registerSystemResponse.guid);
        }
    }, [registerSystemResponse, onCreated]);
    const options = useSystemFormOptions();
    return (React.createElement(FormAdd, { systemResponseError: validationBackend, submittingSystem: submittingSystem, options: options, onSubmit: registerSystem }));
};
